export const validateYoutubeUrl = (url: string | undefined) => {
  if (!url) return false;
  return /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(\?\S*)?$/g.test(
    url,
  );
};

export const getYoutubeEmbedSrc = (url: string) => {
  if (!validateYoutubeUrl(url)) return '';
  const id =
    /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(\?\S*)?$/g.exec(
      url,
    )?.[1];

  return `https://www.youtube.com/embed/${id}`;
};

export const getYoutubeThumbnailSrc = (url: string) => {
  if (!validateYoutubeUrl(url)) return '';
  const id =
    /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(\?\S*)?$/g.exec(
      url,
    )?.[1];

  return `https://img.youtube.com/vi/${id}/hqdefault.jpg`;
};
